import styled from "styled-components";

export const Wrapper = styled.div`
    margin: 15px auto;
    background-color: bisque;
    border-radius: 5px;
    padding: 20px;
   
`

export const Content = styled.div`

    margin: 5px;
    border-radius: 10px;
    background-color: whitesmoke;
    padding: 20px;
    text-align: center;
    animation: rotate_card 0.5s ;

    @keyframes rotate_card {
    from{transform: rotateX(360deg);}
      
    
  
    }

`